import { render, staticRenderFns } from "./RegistrationView.vue?vue&type=template&id=592c8893&scoped=true"
import script from "./RegistrationView.vue?vue&type=script&lang=js"
export * from "./RegistrationView.vue?vue&type=script&lang=js"
import style0 from "./RegistrationView.vue?vue&type=style&index=0&id=592c8893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592c8893",
  null
  
)

export default component.exports